import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import AffiliationsResponsive from "../../components/AffiliationsResponsive/AffiliationsResponsive";

const AffiliationsPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-7">
				<HeroCaption
					title="Library & Resources"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<AffiliationsResponsive/>
		</PageWrapper>
	);
};

export default AffiliationsPage;